import {Component, OnInit} from '@angular/core';
import {DatePipe, NgIf, NgOptimizedImage} from '@angular/common';
import {HeaderModule} from '../../../shared-components/header/header.module';
import {ItemRatingComponent} from '../../../shared-components/item-rating/item-rating.component';
import {ItemsComponent} from '../single-list/components/items/items.component';
import {TranslateModule} from '@ngx-translate/core';
import {
  Column,
  ListExtendedInterface,
  ListInterface, ListItem, ListItemInterface
} from '../../../services/http-services/lists/lists-http-intterfaces';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {ListsHttpService} from '../../../services/http-services/lists/lists-http.service';
import {Meta, Title} from '@angular/platform-browser';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {ShareEntitiesEnums} from '../../../enums/chat-enums';
import {PublicListModalComponent} from '../components/public-list-modal/public-list-modal.component';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {UserRoles} from '../../../enums/general-enums';
import {CheckActiveRolePipe} from '../../../pipes/check-active-role/check-active-role.pipe';

@Component({
  selector: 'app-single-list-public',
  standalone: true,
  imports: [
    DatePipe,
    HeaderModule,
    ItemRatingComponent,
    ItemsComponent,
    NgIf,
    TranslateModule,
    PublicListModalComponent,
    RouterLink,
    CheckActiveRolePipe,
    NgOptimizedImage
  ],
  templateUrl: './single-list-public.component.html',
  providers: [DatePipe]
})
export class SingleListPublicComponent implements OnInit{
  listId = 0;
  list: ListInterface | undefined | ListExtendedInterface | any;
  columns: Column[] = [];
  items: ListItem[] = [];
  searchTerm = '';
  searchSubject = new Subject<string>();
  ShareEntitiesEnums = ShareEntitiesEnums;
  isModalOpen = false;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(
    private actRoute: ActivatedRoute,
    private listsHttpService: ListsHttpService,
    private router: Router,
    private meta: Meta,
    private title: Title,
    private datePipe: DatePipe,
  ) {
  }

  ngOnInit(): void {
    this.getParams();
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    ).subscribe((searchTerm: any) => {
      this.getPublicSingleList(searchTerm);
    });
  }

  getParams(): void {
    this.actRoute.paramMap.subscribe(params => {
      this.listId = Number(params.get('id'));
      this.getPublicSingleList('');
    });
  }

  getPublicSingleList(searchTerm?: string): void {
    this.listsHttpService.getPublicSingleList({search_keyword: searchTerm}, this.listId).then((res: ListInterface) => {
      this.list = res;
      this.columns = res.attributes;
      const dateObj = new Date(this.list.created_at);
      const formattedDate = this.datePipe.transform(dateObj, 'dd.MM.YYYY');

      const keywords = 'thelysts,lyst,list,task,organizer,connect,trip,suggestion,music,food,restaurants,sports,movies,films,tv series,podcasts,life style,cars,boats,app,recommendation,planner,beauty,fashion,celebrities,influencers,museums,golf,ongs'.split(',');

      const titleE = (`${this.list.title} by ${this.list.user.name} TheLysts`).split(' ');
      const titleNotInKeywords = titleE.filter(x => !keywords.includes(x.toLowerCase())).map(x => x.toLowerCase());

      this.title.setTitle(`${this.list.title} by ${this.list.user.name} - TheLysts`);

      this.meta.updateTag({
        name: 'description',
        content: `${this.list.title} by ${this.list.user.name} created on ${formattedDate} - TheLysts`
      });

      this.meta.updateTag({
        name: 'keywords',
        content: titleNotInKeywords.concat(keywords).join(',')
      });

      this.meta.updateTag({
        property: 'og:title',
        content: `${this.list.title} by ${this.list.user.name} - TheLysts`
      });

      this.meta.updateTag({
        property: 'twitter:title',
        content: `${this.list.title} by ${this.list.user.name} - TheLysts`
      });
      this.meta.updateTag({
        property: 'og:description',
        content: `${this.list.title} by ${this.list.user.name} created on ${formattedDate} - TheLysts`
      });
      this.meta.updateTag({
        property: 'twitter:description',
        content: `${this.list.title} by ${this.list.user.name} created on ${formattedDate} - TheLysts`
      });
      if (this.list.og_image_url) {
        this.meta.updateTag({
          property: 'og:image',
          content: this.list.og_image_url
        });
        this.meta.updateTag({
          property: 'twitter:image',
          content: this.list.og_image_url
        });
      } else {
        this.meta.updateTag({
          property: 'og:image',
          content: this.list.lyst_image_url !== null ? this.list.lyst_image_url : 'assets/images/og-image.png'
        });
        this.meta.updateTag({
          property: 'twitter:image',
          content: this.list.lyst_image_url !== null ? this.list.lyst_image_url : 'assets/images/og-image.png'
        });
      }
      this.meta.updateTag({
        property: 'og:url', content: window.location.origin + this.router.url
      });

      this.listsHttpService.getPublicSingleListItem({search_keyword: searchTerm}, this.listId).then((res: ListItemInterface) => {
        this.list.lyst_items_count = res.lyst_items.length;
        this.items = res.lyst_items;
      });
    });
  }

  onSearchTermChanged(searchTerm: string): void{
    this.searchSubject.next(searchTerm);
  }

    protected readonly UserRoles = UserRoles;
}
